module.exports = __webpack_public_path__ + "img/SN.6997b18b.svg";